import { render } from "./DescuentoView.vue?vue&type=template&id=2b33c200&scoped=true"
import script from "./DescuentoView.vue?vue&type=script&lang=js"
export * from "./DescuentoView.vue?vue&type=script&lang=js"

import "./DescuentoView.vue?vue&type=style&index=0&id=2b33c200&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b33c200"]])

export default __exports__